import * as React from 'react';



export default class Zip extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
         <g fill="none" fillRule="evenodd">
            <path fill="#53A9DE" className='activeFill' d="M8.044 13.416l-.51-.738c.203-.142 4.99-3.545 3.472-9.75l.871-.213c1.667 6.817-3.778 10.663-3.833 10.7"/>
            <path stroke="" strokeLinecap="round" strokeLinejoin="round" d="M9.236 12.913c-.351.273-.708.426-1.051.426-2.056 0-4.334-5.111-4.334-7.505a4.334 4.334 0 0 1 8.669 0c0 1.14-.538 2.894-1.312 4.421 0 0-.93 1.846-1.972 2.658z"/>
            <path stroke="" strokeLinecap="round" strokeLinejoin="round" d="M9.977 5.75a1.67 1.67 0 1 1-3.34-.001 1.67 1.67 0 0 1 3.34 0zM10.796 13.13c.23.022.447.044.655.068 1.463.175 2.42.463 2.42.79 0 .533-2.547.965-5.686.965-3.14 0-5.685-.432-5.685-.965 0-.266.636-.507 1.665-.682.29-.05.61-.093.954-.13"/>
        </g>
      </svg>
  
    )
  }
}
